import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, GraduationCap } from 'lucide-react';
import SearchBar from './SearchBar';

const Header = () => {
  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center space-x-3">
            <div className="flex items-center justify-center w-10 h-10 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-lg">
              <BookOpen className="w-6 h-6 text-white" />
            </div>
            <div className="flex flex-col">
              <h1 className="text-lg font-bold text-gray-900">RecursosUPN</h1>
              <p className="text-xs text-gray-600">Lectoescritura</p>
            </div>
          </Link>
          
          {/* Search Bar - Hidden on mobile, shown on desktop */}
          <div className="hidden lg:block flex-1 max-w-lg mx-8">
            <SearchBar />
          </div>
          
          {/* Mobile Search Button */}
          <div className="lg:hidden">
            <SearchBar isCompact={true} />
          </div>
          
          <nav className="hidden md:flex items-center space-x-8">
            <Link 
              to="/" 
              className="text-gray-700 hover:text-emerald-600 transition-colors duration-200 font-medium"
            >
              Inicio
            </Link>
            <Link 
              to="/recursos-digitales" 
              className="text-gray-700 hover:text-emerald-600 transition-colors duration-200 font-medium"
            >
              Recursos Digitales
            </Link>
            <Link 
              to="/recursos-impresos" 
              className="text-gray-700 hover:text-emerald-600 transition-colors duration-200 font-medium"
            >
              Recursos Impresos
            </Link>
            <Link 
              to="/sitios-interes" 
              className="text-gray-700 hover:text-emerald-600 transition-colors duration-200 font-medium"
            >
              Sitios de Interés
            </Link>
          </nav>

          <div className="flex items-center space-x-2 text-sm text-gray-600">
            <GraduationCap className="w-4 h-4" />
            <span className="hidden sm:inline">Universidad Pedagógica Nacional</span>
            <span className="sm:hidden">UPN</span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;